module.exports = __webpack_public_path__ + "static/img/about-background-m.9e69aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/main/about-background-m.png
// module id = Y9Np
// module chunks = 1